import { useRef, useState, useEffect } from 'react';
import './index.scss';
import emailjs from '@emailjs/browser'
import Pacman from 'react-pacman';
import { Link } from 'react-router-dom';
import BackgroundWaves from '../BackgroundWaves';
import { Trans, useTranslation } from 'react-i18next';

/**
 * Contact page with the EmailJS contact form and the Pacman mini game.
 */
const Contact = () => {
    const { t } = useTranslation();
    const refForm = useRef()
    const [startGame, setStartGame] = useState(false);
    const [gameInitialized, setGameInitialized] = useState(false);
    const [privacyAccepted, setPrivacyAccepted] = useState(false);

    // Keep the arrow and space keys from scrolling the page while the game is running.
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (gameInitialized && startGame) {
                if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Space'].includes(e.code)) {
                    e.preventDefault();
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [gameInitialized, startGame]);

    const handleStartClick = () => {
        setGameInitialized(true);
        setStartGame(true);
    };


    const handleRestartClick = () => {
        setStartGame(false);
        setTimeout(() => setStartGame(true), 10);
    };

    const sendEmail = (e) => {
        e.preventDefault()

        if (!privacyAccepted) {
            alert(t('privacy_required'))
            return
        }
        
        emailjs
            .sendForm(
                'service_71sfjzy',
                'template_o6wmu3r',
                refForm.current,
                { publicKey: 'mTpUtEckFLYlDkJMg' }
            )
            .then(
                () => {
                    alert(t('send_success'))
                    window.location.reload(false)
                },
                () => {
                    alert(t('send_error'))
                }

            )
    }
    return (
        <>
            <div className='contact-page'>
                <BackgroundWaves />
                <div className='text-zone'>
                    <div className='text'>
                        <h1>
                            <Trans i18nKey='contact' components={{ 1: <span /> }} />
                        </h1>
                        <p>{t('contact_text')}</p>
                    </div>
                    <div className="contact-form">
                        <form ref={refForm} onSubmit={sendEmail}>
                            <ul className='contact'>
                                <li className="half">
                                    <input placeholder={t('form_name')} type="text" name="name" required />
                                </li>
                                <li className="half">
                                    <input
                                        placeholder={t('form_email')}
                                        type="email"
                                        name="email"
                                        required
                                    />
                                </li>
                                <li>
                                    <input
                                        placeholder={t('form_subject')}
                                        type="text"
                                        name="subject"
                                        required
                                    />
                                </li>
                                <li>
                                    <textarea
                                        placeholder={t('form_message')}
                                        name="message"
                                        required
                                    ></textarea>
                                </li>
                                <li className="privacy-checkbox">
                                    <label className="checkbox-container">
                                        <input 
                                            type="checkbox"
                                            checked={privacyAccepted}
                                            onChange={(e) => setPrivacyAccepted(e.target.checked)}
                                            required
                                        />
                                        <span className="checkmark"></span>
                                        <span className="checkbox-text">
                                            <Trans
                                                i18nKey='privacy_consent'
                                                components={{ 1: <Link to="/impressum" target="_blank" rel="noopener noreferrer" /> }}
                                            />
                                            {' *'}
                                        </span>
                                    </label>
                                </li>
                                <li>
                                    <input 
                                        type="submit" 
                                        className={`flat-button ${!privacyAccepted ? 'disabled' : ''}`}
                                        value={t('form_send')}
                                        disabled={!privacyAccepted}
                                    />
                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
                <div className='pacman'>
                    <div className='pacman-frame'>
                        {!gameInitialized ? (
                            <div className='game-start-section'>
                                <h3>{t('game_title')}</h3>
                                <p>{t('game_text')}</p>
                                <button onClick={handleStartClick} className='start-button'>{t('game_start')}</button>
                            </div>
                        ) : (
                            <>
                                {startGame && <Pacman gridSize={20} />}
                                <button onClick={handleRestartClick}>{t('game_restart')}</button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}
export default Contact;